import { render, staticRenderFns } from "./NoPermissiondemo.vue?vue&type=template&id=08e18d7e&scoped=true"
import script from "./NoPermissiondemo.vue?vue&type=script&lang=js"
export * from "./NoPermissiondemo.vue?vue&type=script&lang=js"
import style0 from "./NoPermissiondemo.vue?vue&type=style&index=0&id=08e18d7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e18d7e",
  null
  
)

export default component.exports